<template>
  <div class="flex -mx-3">
    <div class="flex-1 px-3">
      {{ adset.name }}
    </div>
    <div class="w-24 px-3 text-center">
      {{ impressions | thousands }}
    </div>
    <div class="w-24 px-3 text-center">
      {{ reach | thousands }}
    </div>
    <div class="w-24 px-3 text-center">
      {{ inlineLinkClicks | thousands }}
    </div>
    <div class="w-24 px-3 text-center">{{ costPerClick }}&euro;</div>
    <div class="w-24 px-3 text-center">{{ conversions }}&#37;</div>
    <div class="w-24 px-3 text-center">{{ spend }}&euro;</div>
    <div class="w-24 px-3">
      {{ adset.status }}
    </div>
  </div>
</template>

<script>
const sumProp = (prop) => (sum, obj) => sum + 1 * obj[prop];

export default {
  name: 'DataIteratItem',
  props: {
    adset: {
      type: Object,
      required: true,
    },
  },
  computed: {
    impressions() {
      return (this.adset?.adLifetimeReports || []).reduce(sumProp('impressions'), 0);
    },
    reach() {
      return (this.adset?.adLifetimeReports || []).reduce(sumProp('reach'), 0);
    },
    inlineLinkClicks() {
      return (this.adset?.adLifetimeReports || []).reduce(sumProp('inlineLinkClicks'), 0);
    },
    spend() {
      return (this.adset?.adLifetimeReports || []).reduce(sumProp('spend'), 0);
    },
    costPerClick() {
      if (!this.spend) return 0;
      if (!this.inlineLinkClicks) return this.spend;
      return 1 * (this.spend / this.inlineLinkClicks).toFixed(2);
    },
    conversions() {
      if (!this.inlineLinkClicks) return 0;
      return 1 * (this.inlineLinkClicks / this.reach).toFixed(2);
    },
  },
};
</script>
